<script>
    export let title;
    export let hint;
    export let moreHint
</script>
<div class="title">
    <h4>{title}</h4>
    <div class="hint">{hint}</div>
    {#if moreHint !== undefined}
        <div class="hint">{moreHint}</div>
    {/if}
</div>

<style>
    .title {
        text-align: center;
    }

    h4 {
        margin: 0;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        color: #020202;
    }

    .hint {
        margin-top: 4px;
        font-weight: 400;
        transform: scale(calc(10 / 12));
        font-size: 12px;
        line-height: 14px;
        color: #333333;
    }
</style>
